export default {
    items: [],
    item_details: [],
    item_secondary_details: [],
    next_page_index: 1,
    start_record: 0,
    length_record: 40,
}